import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import LeadDetail from "@/pages/admin/LeadDetail";
import Stats from "@/pages/admin/Stats";
import Audience from "@/pages/admin/Audience";
import Bookings from "@/pages/admin/Bookings";
import LegalPage from "@/pages/LegalPage";
import PillarPage from "@/pages/PillarPage";
import RouteTracker from "@/components/RouteTracker";
import CookieConsent from "@/components/CookieConsent";
import { captureAttribution } from "@/lib/tracking";

captureAttribution();

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <RouteTracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/test" element={<Quiz />} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
              <Route path="/admin/audience" element={<ProtectedRoute><Audience /></ProtectedRoute>} />
              <Route path="/admin/bookings" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />
              <Route path="/admin/leads/:id" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
              <Route path="/mentions-legales" element={<LegalPage doc="legal" />} />
              <Route path="/confidentialite" element={<LegalPage doc="privacy" />} />
              <Route path="/sport-sante-bruxelles" element={<PillarPage slug="sport-sante-bruxelles" />} />
              <Route path="/perte-de-poids-apres-40-ans" element={<PillarPage slug="perte-de-poids-apres-40-ans" />} />
              <Route path="/reprise-du-sport-en-douceur" element={<PillarPage slug="reprise-du-sport-en-douceur" />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
          <CookieConsent />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
